import React from 'react';
import * as S from './styles';

interface ISelectableButton {
  className?: string;
  label: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
  width?: number;
}

const SelectableButton = ({
  className,
  label,
  onClick,
  selected = false,
  disabled = false,
  width
}: ISelectableButton) => (
  <S.Button
    className={className}
    onClick={!disabled ? onClick : undefined}
    selected={selected}
    disabled={disabled}
    width={width}
  >
    {label}
  </S.Button>
);

export default SelectableButton;
